import { Box, CircularProgress, Skeleton } from "@mui/material";

import type { FC } from "react";

export const ImageLoading: FC = () => (
  <>
    <Skeleton sx={{ width: "100%", height: "100%" }} data-testid="skeleton" variant="rectangular" />
    <Box
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "16px",
      }}
    >
      <CircularProgress sx={{ width: "32px", height: "32px" }} />
      Loading
    </Box>
  </>
);
